import Box from "@/components/Box";
import {
  dashboardMainStackMaxWidth,
  dashboardPageMaxWidth,
  dashboardSidebarContentGap
} from "@/components/organisations/learningHub/dashboardLayout";
import { SHOP_FILTER_DESKTOP_MIN_WIDTH } from "@/components/organisations/shop/shopFilterBreakpoints";
import { SHOP_BREAKPOINTS } from "@/components/organisations/shop/shopTheme";
import styled from "styled-components";

const ExpertsFiltersRow = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: ${dashboardPageMaxWidth}px;
  margin-left: auto;
  margin-right: auto;

  @media screen and (min-width: ${SHOP_FILTER_DESKTOP_MIN_WIDTH}) {
    display: grid;
    grid-template-columns: auto minmax(0, ${dashboardMainStackMaxWidth}px);
    grid-template-rows: auto auto;
    justify-content: center;
    align-items: start;
    column-gap: ${dashboardSidebarContentGap[1]}px;
    row-gap: ${dashboardSidebarContentGap[1]}px;
  }

  @media screen and (min-width: ${SHOP_BREAKPOINTS.md}) {
    column-gap: ${dashboardSidebarContentGap[2]}px;
    row-gap: ${dashboardSidebarContentGap[2]}px;
  }
`;

const ExpertsFilterSidebarColumn = styled(Box)`
  display: none;

  @media screen and (min-width: ${SHOP_FILTER_DESKTOP_MIN_WIDTH}) {
    display: block;
    grid-column: 1;
    grid-row: 2;
  }
`;

const ExpertsToolbarColumn = styled(Box)`
  min-width: 0;
  width: 100%;
  max-width: ${dashboardMainStackMaxWidth}px;

  @media screen and (min-width: ${SHOP_FILTER_DESKTOP_MIN_WIDTH}) {
    grid-column: 2;
    grid-row: 1;
  }
`;

const ExpertsPageContentContainer = styled(Box)`
  min-width: 0;
  width: 100%;
  max-width: ${dashboardMainStackMaxWidth}px;

  @media screen and (min-width: ${SHOP_FILTER_DESKTOP_MIN_WIDTH}) {
    grid-column: 2;
    grid-row: 2;
  }
`;

/** Find-a-practitioner: filter + list centered as a pair inside the 1920px content area. */
export default function ExpertsPageFiltersLayout({ filterSidebar, toolbar, children }) {
  return (
    <ExpertsFiltersRow px={0} data-component-name="ExpertsPageFiltersLayout">
      <ExpertsFilterSidebarColumn>{filterSidebar}</ExpertsFilterSidebarColumn>
      {toolbar ? <ExpertsToolbarColumn>{toolbar}</ExpertsToolbarColumn> : null}
      <ExpertsPageContentContainer data-component-name="ExpertsPageContentContainer">
        {children}
      </ExpertsPageContentContainer>
    </ExpertsFiltersRow>
  );
}
